exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "\n.pRelative[data-v-44da5c37] {\n  position: relative;\n}\n.colorCircle[data-v-44da5c37] {\n  width: 1.875rem;\n  height: 1.875rem;\n}\n.colorCircle.selected[data-v-44da5c37] {\n    border-color: #8ca0b3;\n    border-width: 0.1875rem;\n    border-style: solid;\n    text-align: center;\n    padding-top: 1px;\n}\n.colorCircle.selected[data-v-44da5c37]::before {\n    font-family: 'PluraloIconSet' !important;\n    content: \"\\E911\";\n    color: #fff;\n    font-size: 0.7rem;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"id":"data-v-44da5c37","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/inventory/products/ProductEdit.vue
// module id = 1523
// module chunks = 0